/** @jsx jsx */
import { jsx } from '@emotion/core';
import { times } from 'ramda';
import { FC, ReactElement, useCallback } from 'react';
import { composeStyles } from 'features/Theme';
import styles from './styles';

interface PropTypes {
  steps: number;
  activeStep?: number;
}

const Stepper: FC<PropTypes> = ({ steps, activeStep }) => {
  const renderStep = useCallback(
    (n: number): ReactElement => {
      return (
        <li
          aria-current={activeStep !== undefined && activeStep === n && 'step'}
          key={n}
          css={composeStyles([
            styles.step,
            activeStep !== undefined && activeStep >= n && styles.activeStep,
          ])}
        >
          <span css={styles.visuallyHidden}>
            Step {n + 1} of {steps}
            {activeStep !== undefined && activeStep > n ? '(completed)' : ''}
          </span>
        </li>
      );
    },
    [activeStep, steps],
  );

  return <ol css={styles.container}> {times(renderStep, steps)} </ol>;
};

export default Stepper;
